import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import packageJson from '../../package.json';

export const useAppVersion = () => {
  const localVersion = packageJson.version;

  const { data: remoteVersion, isSuccess } = useQuery({
    queryKey: ['app-version'],
    queryFn: async () => {
      const res = await fetch(`/version.txt`, { cache: 'no-store' });
      if (!res.ok) throw new Error('Failed to fetch version');
      return res.text();
    },
    refetchInterval: 300_000, // check every 300 seconds
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    console.log(`[App Version] Local version: ${localVersion}! `);
  }, [localVersion]);

  useEffect(() => {
    if (!isSuccess) return;
    if (remoteVersion.trim() !== localVersion.trim()) {
      console.warn(
        `[App Version] Local version (${localVersion}) differs from remote version (${remoteVersion}). Reloading...`
      );
      window.location.reload();
    } else {
      console.log(
        `[App Version] Remote version: ${remoteVersion} (matches local: ${localVersion})`
      );
    }
  }, [isSuccess, remoteVersion, localVersion]);

  return { localVersion, remoteVersion };
};
